import React, { useState } from 'react'
import { motion } from 'framer-motion';

interface StoreSortingProps {
  options: { value: string, label: string }[];
  orderingOn: null | string;
  handleSortingChange: (option: string) => void;
}

export default function StoreSorting({
  options,
  orderingOn,
  handleSortingChange
}: StoreSortingProps) {
  return (
    <div className='hidden h-14 md:flex gap-x-8 border border-t-none border-l-none border-r-none border-solid border-neutral-200'>
      {options.map((option) => (
        <button 
          key={option.value}
          type="button"
          onClick={() => handleSortingChange(option.value)}
          className='w-fit h-full px-4 relative flex items-center cursor-pointer'
        >
          <span 
            className={`text-sm ${orderingOn === option.value ? 'text-neutral-800' : 'text-neutral-400'} font-manrope font-semibold capitalize`}
          >
            {option.label}
          </span>

          {orderingOn === option.value && (
            <motion.span 
              layoutId='activeOpt'
              transition={{ type: 'spring', duration: 0.5 }}
              className='w-full h-0.5 absolute bottom-0 bg-brand' 
            />
          )}
        </button>
      ))}
    </div>
  )
}
